import React, { Component } from 'react';
import { connect } from 'react-redux';
import TableHeader from '../../helper/tableHeader';
import moment from 'moment';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {take} from 'ramda';
import { Decimal } from "decimal.js";


class TradeHistory extends Component {
  render() {
    let items = this.props.orders && this.props.orders.length > 0 ? this.renderOrders(this.props.orders) : this.renderWait();

    let headerItems = [
        `Price (${this.props.market.denomination.replace('NRG','OL')})`,
        `Amt (${this.props.market.asset})`,
        `Total (${this.props.market.denomination.replace('NRG','OL')})`,
        `Time`
    ]

    return (
      <div className='col s12'>
        <h6 className='tradeHistoryTitle'>Trade History </h6>
        <div className='col s12 section' style={{marginTop:'5px'}}>
          <TableHeader items={headerItems} />
          <div className="col s12 historybook" id={'historytable'}>
            <table className={"white-text order-book"} style={{tableLayout:"fixed",fontSize:"0.9em"}}>
              <tbody>
                {this.renderOrders(this.props.orders)}
                {this.renderWait()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
  renderOrders(offers){
    var items = offers.map(({isBlank,amount,price,timestamp,color,txHash,txOutputIndex},i) => {
      if(isBlank) return <tr>{new Array(4).fill(<td>-</td>)}</tr>
      let total = new Decimal(price).mul(new Decimal(amount)).toString();
      let tds = [price,amount,total,moment(timestamp).format('HH:mm:ss')].map((i,j) => {
        if(j == 0) return (<td key={Math.random()} style={{color}}>{i.toString().substring(0,10)}</td>)
        if(j == 3) return (<td key={Math.random()} style={{color:'grey'}}>{i.toString().substring(0,10)}</td>)
        else return (<td key={Math.random()}>{i.toString().substring(0,10)}</td>)
      })
      return (
        <CSSTransition key={txHash+txOutputIndex} timeout={500} classNames="item">
          <tr onMouseOver={()=>{console.log({txHash,txOutputIndex})}}>{tds}</tr>
        </CSSTransition>
      );
    });
    return (items);
  }
  renderWait(){
    return new Array(14-this.props.orders.length).fill(0).map((_, i) => {
      return (<tr key={i}>{new Array(4).fill(0).map((_, j) => (<td key={j}>-</td>))}</tr>)
    })
  }
}

function mapStateToProps(state,props) {
  let market = state.ui_marketplace.market;
  let pairs = state.orderbook.matched_pairs;
  let orders = pairs[market.type][`${market.asset.toUpperCase()}/${market.denomination.toUpperCase()}`].pastOrders;
  return {market, orders:take(14,orders)};
}

export default connect(mapStateToProps,{})(TradeHistory);
